import { SHOW_PROGRESS_BAR, CLOSE_PROGRESS_BAR } from "./actionTypes";

export function showProgress(progress) {
  return { type: SHOW_PROGRESS_BAR, data: { progress } };
}

export function closeProgress() {
  return { type: CLOSE_PROGRESS_BAR };
}
